import { DataFieldType } from "src/types/data-field.types";
import { createNodeDef } from "../../nodes.helpers";
import { randCodeSnippet } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randCodeSnippet>[0], undefined>;
type Lang = Exclude<Options["lang"], undefined>;

const langs: Record<Lang, string> = {
  bash: "Bash",
  c: "C",
  "c#": "C#",
  "c++": "C++",
  go: "Go",
  html: "HTML",
  java: "Java",
  javascript: "JavaScript",
  php: "PHP",
  python: "Python",
  rust: "Rust",
  sql: "SQL",
  swift: "Swift",
};

export const randCodeSnippetNodeDef = createNodeDef({
  type: "randCodeSnippet",
  displayName: "Code Snippet",
  defaultName: "codeSnippet",
  fields: [
    {
      type: DataFieldType.SELECT,
      key: "lang",
      label: "Language",
      options: langs,
    },
  ],
  initialData: (): { lang: Lang } => ({ lang: "javascript" }),
  generate: ({ node }) => {
    return randCodeSnippet({ lang: node.data.lang });
  },
});
